var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('a',{on:{"click":function($event){_vm.locked ? _vm.unlockInvoice({ playerId: _vm.playerId }) : _vm.lockInvoice({ playerId: _vm.playerId })}}},[_c('span',{attrs:{"id":_vm.locked ? 'unlock' : 'lock'}})])])}
var staticRenderFns = []

export { render, staticRenderFns }